export enum CommentType {
    Account = 1,
    SEAAUseOnly = 2
}